module.exports = "https://static.wmbcdn.com/uniweb/images/7eccf0032b4b55030f1c03e2099e5dfd.png";